import * as React from 'react';
import { DataTable } from 'primereact/datatable';
import { useRef, useState } from 'react';
import { Column } from 'primereact/column';
import _ from 'lodash';
import { ProductGridModel } from '../models';
import { emptyMessageTemplate, headerGroup, lastSyncAtBodyTemplate, myobErrorMessageTemplate, netoErrorMessageTemplate, rowExpansionTemplate, SourceInventoriedTemplate, TargetInventoriedTemplate } from '../GridBodyTemplates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSlash, faSync } from '@fortawesome/free-solid-svg-icons';

interface IProductGridErrorComponentProp {
    productData: Array<ProductGridModel>,
    loading: boolean,
    error?: string,
    lastRefreshedAt?: Date,
    onRefresh?: () => void,
    /** Authoritative connector failed-product count from the API `total`, not the
     * loaded page length. Falls back to productData.length only if not provided. */
    totalRecords?: number,
}

const ProductGridErrorComponent: React.FC<IProductGridErrorComponentProp> = ({ productData, loading, error, lastRefreshedAt, onRefresh, totalRecords }) => {
    const dt = useRef<DataTable>(null);
    const [expandedRows, setExpandedRows] = useState<Array<ProductGridModel>>([]);

    const reset = () => {
        dt.current?.reset();
    }

    const header = (
        <div className="d-flex justify-content-between">
            <h5 className="text-left">Failed Products</h5>
            <div className="col-6 text-right d-flex justify-content-end align-items-center">
                {lastRefreshedAt && (
                    <small className="text-muted mr-3">
                        Last refreshed: {lastRefreshedAt.toLocaleTimeString()}
                    </small>
                )}
                {onRefresh && (
                    <button
                        type="button"
                        className="btn btn-outline-secondary ml-2"
                        onClick={onRefresh}
                        disabled={loading}
                    >
                        <FontAwesomeIcon className="mr-2" icon={faSync} />
                        Refresh
                    </button>
                )}
                <button
                    type="button"
                    className="btn btn-outline-secondary ml-2"
                    onClick={reset}
                >
                    <div className="fa-layers ml-2">
                        <FontAwesomeIcon className="mr-2" icon={faFilter} />
                        <FontAwesomeIcon className="mr-2" icon={faSlash} />
                    </div>
                    Clear
                </button>
            </div>
        </div>
    );

    return (
        <div className="container-fluid">
            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}
            <DataTable
                ref={dt}
                // dataKey="Number"
                header={header}
                headerColumnGroup={headerGroup}
                value={productData}
                className=""
                autoLayout
                sortField="lastSyncAtForFilter"
                sortOrder={-1}
                emptyMessage={emptyMessageTemplate}
                lazy={loading}
                loading={loading}
                paginator
                rows={10}
                selectionMode="multiple"
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e?.data as Array<ProductGridModel>)}
                rowExpansionTemplate={(data: any) => rowExpansionTemplate([data])}
                totalRecords={typeof totalRecords === 'number' ? totalRecords : productData?.length}
                rowsPerPageOptions={[10, 20, 50]}
                paginatorClassName="p-jc-end"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                <Column expander style={{ width: '3em' }} />
                <Column field="NetoProduct.SKU" />
                <Column field="MyobProduct.Number" />
                <Column field="NetoProduct.Name" />
                <Column field="MyobProduct.Name" />
                <Column body={SourceInventoriedTemplate} field="NetoProduct.IsInventoriedNeto" />
                <Column body={TargetInventoriedTemplate} field="MyobProduct.IsInventoriedMyob" />
                <Column field="NetoProduct.syncErrorMessage" body={netoErrorMessageTemplate} />
                <Column field="MyobProduct.syncErrorMessage" body={myobErrorMessageTemplate} />
                <Column filterField="LastSyncAt" field="lastSyncAtForFilter" body={lastSyncAtBodyTemplate} />
            </DataTable>
        </div>
    )
}

export default ProductGridErrorComponent